import React from 'react';
import { IconButton, Menu } from '@material-ui/core';
import { MoreHoriz, MoreVert } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { useMenuRef } from 'modules/shell/hooks';

const LongMenu = ({ children, classes, horizontal, dark }) => {
  const [anchorEl, open, handleClick, handleClose] = useMenuRef();

  return (
    <>
      <IconButton
        data-testid="more"
        classes={{ root: !dark && classes.white }}
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {horizontal ? <MoreHoriz /> : <MoreVert />}
      </IconButton>
      <Menu
        data-testid="menu"
        classes={{ paper: classes.paper, list: classes.list }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
      >
        {children}
      </Menu>
    </>
  );
};

LongMenu.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string),
  horizontal: PropTypes.bool,
  dark: PropTypes.bool,
};

LongMenu.defaultProps = {
  children: '',
  classes: {},
  horizontal: null,
  dark: null,
};

export default LongMenu;
